import React from 'react';

import AccountCircle from '@mui/icons-material/AccountCircle';
import { LoadingButton } from '@mui/lab';
import { Input, Typography, InputAdornment } from '@mui/material';
import { Box } from '@mui/system';
import { useUpdateAthenaUsernameMutation } from 'src/common/apis/AdminApi';
import { User } from 'src/common/types/User';
import SnackbarUtils from 'src/common/utils/SnackbarUtilsConfigurator';

type Props = {
  user: User;
};

const AthenaUsernameBox: React.FC<Props> = ({ user }) => {
  const [usernames, setUsernames] = React.useState(user.athenaUsername);
  const [isEdit, setIsEdit] = React.useState(false);

  const [updateUsername, { isLoading }] = useUpdateAthenaUsernameMutation();

  const onButtonClick = async () => {
    if (!isEdit) {
      setIsEdit(true);
      return;
    }

    await updateUsername({
      id: user.id.toString(),
      usernames: usernames || '',
    })
      .unwrap()
      .then((res) => {
        SnackbarUtils.success(res.message);
        setIsEdit(false);
      });
  };

  return (
    <Box
      className='user-content-container'
      style={{
        minWidth: '160px',
        marginBottom: '0',
      }}
    >
      <Box>
        <Typography variant='subtitle'>Athena Usernames </Typography>
      </Box>
      <Box sx={{ marginBottom: '16px' }}>
        <Typography variant='body2' color='#00214580'>
          (comma separated)
        </Typography>
      </Box>

      <Box className='row'>
        <Input
          value={usernames}
          disabled={!isEdit || isLoading}
          onChange={(e) => setUsernames(e.target.value)}
          placeholder='Enter usernames'
          startAdornment={
            <InputAdornment position='start'>
              <AccountCircle color={isEdit ? 'primary' : 'secondary'} />
            </InputAdornment>
          }
        />
        <LoadingButton
          onClick={onButtonClick}
          loading={isLoading}
          variant='contained'
          color='primary'
          disableElevation
          sx={{
            borderRadius: '16px',
          }}
        >
          {isEdit ? 'Save' : 'Edit'}
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default AthenaUsernameBox;
